export interface IModel {
  name: string;
  slug: string;
  img: string;
  price: number;
  bottles: number;
  bedrooms: number[];
  areas: number[];
}

export const models: IModel[] = [
  {
    name: "PakMonaco",
    slug: "PakMonaco",
    price: 198000,
    bottles: 420000,
    bedrooms: [2, 3],
    areas: [1362, 1000, 1500],
    img: "/images/models/signatures/PakMonaco.jpg",
  },
  {
    name: "PakAlps",
    slug: "PakAlps",
    price: 78000,
    bottles: 155000,
    bedrooms: [1, 2],
    areas: [392, 522],
    img: "/images/models/signatures/PakAlps.jpg",
  },
  {
    name: "PakTokyo",
    slug: "PakTokyo",
    price: 88000,
    bottles: 185000,
    bedrooms: [1, 2],
    areas: [483, 663],
    img: "/images/models/signatures/PakTokyo.jpg",
  },
  {
    name: "PakShiraz",
    slug: "PakShiraz",
    price: 50000,
    bottles: 110000,
    bedrooms: [],
    areas: [259],
    img: "/images/models/signatures/PakShiraz.jpg",
  },
  {
    name: "PakStockholm",
    slug: "PakStockholm",
    price: 35000,
    bottles: 75000,
    bedrooms: [],
    areas: [173],
    img: "/images/models/signatures/PakStockholm.jpg",
  },
  {
    name: "PakNewYork",
    slug: "PakNewYork",
    price: 28000,
    bottles: 65000,
    bedrooms: [],
    areas: [132],
    img: "/images/models/signatures/PakNewYork.jpg",
  },
  {
    name: "PakMontréal",
    slug: "PakMontreal",
    price: 30000,
    bottles: 60000,
    bedrooms: [],
    areas: [128],
    img: "/images/models/signatures/PakMontreal.jpg",
  },
];
